import 'appstart';
//import 'SCSSEntries/hotel.scss';
import 'Vendors/knockout/knockout-pack';
import { GetBreakpointWidth, GetBreakpointHeight } from 'Utils/globals-bp';
//import { isTouch, isApplePie, is_iPhone, IsPortraitMode, IsLandscapeMode, DetectIE } from 'Utils/device-utils';
import { showSection, hideSection } from 'Utils/section';
import { scrollToHotelPrices } from 'Utils/ha-search-single-result-functions';
import { SetHotelRoomsTooltips } from 'Utils/ha-mytriplogic-functions';

global.SetHotelRoomsTooltips = SetHotelRoomsTooltips;

//global.isTouch = /Android|webOS|iPhone|iPad|iPod|BlackBerry|windows phone|WindowsPhone/i.test(navigator.userAgent.toLowerCase());
//global.isApplePie = /iPhone|iPad|iPod/i.test(navigator.userAgent.toLowerCase());
//global.is_iPhone = /iPhone/i.test(navigator.userAgent.toLowerCase());

import 'Utils/formatters';


import 'SrcJS/knockout-extensions/knockout.spinner';

import 'Utils/mere.js';
//import 'Utils/slider.js'; //??? //2021-06-14 Disabled
//import 'Modules/map-container';
import 'Modules/hotel-mapbox';
import 'Modules/hotel-page-nav';

//import(/* webpackChunkName: "searchbar-module" */ 'searchbar');
import(/* webpackChunkName: "search-single-result-module" */ 'search-single-result');
import(/* webpackChunkName: "sections-module" */ 'Modules/sections/lowCostCalendar.js'); // temp test lowCostCalendar
import(/* webpackChunkName: "sections-module" */ 'Modules/sections/hotelReviews_TrustYou.js');
import(/* webpackChunkName: "sections-module" */ 'Modules/sections/hotelList.js');



AppLoader.ready(function () {
    let moreLink = $('#beskrivelse #moreLink').html();
    let lessLink = $('#beskrivelse #lessLink').html();

    $('.hotel-description .readmoreHeight').readmore({
        selector: '.hotel-description .readmoreHeight',
        speed: 100,
        collapsedHeight: 48,
        heightMargin: 26,
        embedCSS: false,
        //moreLink: '<a href="#" class="mere mere-button-sm-down mere-link-md-up mere-button-end">'+ AppData.Translations["hotelpage.read-more"] + '</a>',
        //lessLink: '<a href="#" class="mere mere-button-sm-down mere-link-md-up mere-button-end expanded">' + AppData.Translations["hotelpage.show-less"] + '</a>'
        moreLink: moreLink,
        lessLink: lessLink,
    }).removeClass('readmore-placeholder');
});

AppLoader.ready(function () {
    let refresh_map = function () {
        AppLoader.raf(function () {
            if (map && typeof map.resize == "function") {
                map.resize();
            }
        });
    };


    //$('.panel-heading[data-target="#info-and-facts-panel-body"]').collapse();
    //$('#info-and-facts-panel-body').on('shown.bs.collapse', function () {
    //    if (map && typeof map.resize == "function") {
    //        map.resize();
    //    }
    //});
    // 2019-12-30 :BootStrap: event does not rise when 'bs-scripts.min.js' script's tag is defined early 
    //$('#info-and-facts-panel-body').on('show.bs.collapse', function () {
    //    refresh_map();
    //});
    $('.panel-heading[data-target="#info-and-facts-panel-body"]').on('click', function (e) {
        refresh_map();
    });

    $('.info-and-facts .attractions-text.readmoreHeight').readmore({
        selector: '.info-and-facts .attractions-text.readmoreHeight',
        speed: 100,
        collapsedHeight: 180,
        heightMargin: 24,
        embedCSS: false,
        moreLink: '<a href="#" class="mere mere-button">' + AppData.Translations["hotelpage.show-more"] + '</a>',
        lessLink: '<a href="#" class="mere mere-button expanded">' + AppData.Translations["hotelpage.show-less"] + '</a>',
        afterToggle: function (trigger, element, expanded) {
            //if (expanded) {
            if (GetBreakpointWidth() >= 1024) {
                refresh_map();
            }
            //}
        }
    }).removeClass('readmore-placeholder');
});












//**** show ******

var ShowLessRooms = function () {
    var minRoomTypes = AppData.HotelShow.MinRoomTypesOnPage / 2;
    $('.room-types').each(function (i, e) {
        $(e).find('.room-fix').each(function (j, r) {
            if (j > (minRoomTypes - 1))
                $(r).hide();
            else
                $(r).show();
        });
    });

    $('.room-types').find('.show-more-rooms').show();
    $('.room-types').find('.show-less-rooms').hide();

    if ($('.room-types').find('.room-fix').length <= minRoomTypes) {
        $('.room-types').find('.more-room-types').hide();
        $('.room-types').find('.show-less-rooms').hide();
    } else {
        $('.room-types').find('.more-room-types').show();
    }
}


var ShowMoreRooms = function () {
    $('.room-types').each(function (i, e) {
        $(e).find('.room-fix').each(function (j, r) {
            $(r).show();
        });
    });
    $('.room-types').find('.show-more-rooms').hide();
    $('.room-types').find('.show-less-rooms').show();
}

var serializedRoomTypes = AppData.HotelShow.SerializedRoomTypes;

AppLoader.ready(function () {

    ShowLessRooms();
    //searchViewModel.UpdateFromDataRoomTypes(serializedRoomTypes);


    $(".room-details").click(function () {
        $(this).parent().find(".room-imageanddescription").toggle();
    });

    $(".price-split, .hotel-packages").hide();
    $(".toggle-price-examples").on("click", function (e) {
        var el = $(this);
        //el.text() == el.data("text-swap") ? el.text(el.data("text-original")) : el.text(el.data("text-swap"));
        if (el.text() == el.attr("data-text-swap")) {
            el.text(el.attr("data-text-original"));
        } else {
            if (!el.attr("data-text-original"))
                el.attr("data-text-original", el.text() ? el.text().trim() : '&nbsp;&nbsp;&nbsp;');
            el.text(el.attr("data-text-swap"));
        }

        $(".price-split, .hotel-packages").slideToggle(500);
        e.preventDefault();
    });

});


AppLoader.ready(function () {

    let c = 0;
    $('.facilities .readmoreHeight').each(function () {
        let $this = $(this);
        let id = $this.attr('id');
        if (!id || id == '') {
            id = 'facilities__readmoreHeight-' + c;
            $this.attr('id', id);
            c++;
        }
        let startOpen= !!$this.data('start-expanded');
        $this.readmore({
            //selector: '.facilities .readmoreHeight',
            selector: '#' + id,
            speed: 100,
            //collapsedHeight: 264,
            heightMargin: 24,
            embedCSS: false,
            startOpen: startOpen,
            moreLink: '<a href="#" class="mere mere-button-sm-down mere-link-md-up">' + AppData.Translations["hotelpage.show-more"] + '</a>',
            lessLink: '<a href="#" class="mere mere-button-sm-down mere-link-md-up expanded">' + AppData.Translations["hotelpage.show-less"] + '</a>'
        }).removeClass('readmore-placeholder');
    });

    var update_readmore_inside_panel = function (panel_heading) {
        let target = $(panel_heading).attr('data-target');
        if (target && target.length > 0) {
            let $target = $(target);
            if ($target && $target.length > 0) {
                setTimeout(function () {
                    let $readmore = $target.find('[data-readmore], .readmoreHeight');
                    $readmore.each(function () {
                        let $current = $(this);
                        //if ($current.css('max-height') == 'none') {
                        //    let maxHeight = $current.data('readmoreHeight--max-height') || '';
                        //    $current.css('max-height', maxHeight);
                        //}
                        $current.readmore('update');
                    });
                }, 300);
            }
        }
    };
    $(window).resize(function () {
        $('.panel-heading').each(function () {
            update_readmore_inside_panel(this);
        });
    });
    $('.panel-heading').on('click', function (e) {
        update_readmore_inside_panel(this);
    });
});


AppLoader.ready(function () {
    $('#prices-sticker-button').on('click', function (e) {
        if (typeof searchViewModel != "undefined"
            && searchViewModel.ValidateSearchConditions_PageID(false)
            && searchViewModel.ValidateSearchConditions_DepartureAirportCode(false)
            && searchViewModel.ValidateSearchConditions_Rooms(false)
            && searchViewModel.HasDates()) {
            scrollToHotelPrices(0, 500);
            e.preventDefault();
        }
    });
});




function pageScrollTo(element, offset) {
    let $elm = $(element);
    if ($elm.length > 0) {
        if (GetBreakpointWidth() < 768) {
            let expand_panel = function ($panel) {
                if ($panel.length > 0) {
                    // 2019-12-28 :Bootstrap: correct way but throws exception 'collapse is not a function'
                    //let $panel_heading = $panel.find('.panel-heading[data-toggle="collapse"]');
                    //if($panel_heading.length > 0 && typeof $panel_heading.collapse === 'function'){
                    //    $panel_heading.collapse('show');
                    //}
                    // small workaround to make this works
                    $panel_heading = $panel.find('.panel-heading[data-toggle="collapse"]').not('.panel-heading[aria-expanded="true"]');
                    if ($panel_heading.length > 0) {
                        $panel_heading.trigger('click');
                    }
                }
            }
            expand_panel($elm.closest('.panel, .panel-sm-down'));
            expand_panel($elm.find('.panel, .panel-sm-down'));
        }

        var scrollto = $elm.first().offset().top + offset;
        $("html, body").delay(100).animate({ scrollTop: scrollto }, 1000);
    }
};
global.pageScrollTo = pageScrollTo;


AppLoader.ready(function () {
    let fixedWrapper = '.prices-sticker-wrapper.sticked-bottom-md-down';
    let pricesButtonHolder = '.prices-sticker-container';
    let checkoutButtonHolder = '.checkout-sticker-container';

    var isUsed = function () {
        return GetBreakpointWidth() < 768;
    };

    var has_search_result = function() {
        return !!(searchViewModel
            // // ko-visible wizard
            // && !searchViewModel.SearchInProgress() 
            // && !searchViewModel.FlightSearchInProgress() 
            // && searchViewModel.RetrievingDataReady() 
            // && searchViewModel.HasDates() 
            // && searchViewModel.SingleHotelResult() 
            // && !searchViewModel.HasHotelRequestPrice()

            // ko-visible
            && !searchViewModel.SearchInProgress()
            && searchViewModel.RetrievingDataReady()

            // ko-if
            && searchViewModel.HasDepartureAirportCode()
            && searchViewModel.HasDates()
            && searchViewModel.SingleHotelResult()
            && !searchViewModel.HasHotelRequestPrice()

            // ko-visible
            && searchViewModel.IsSameWithLastSearchConditions(true)
        );
    };


    var handler_Resize = function () {
        let $fixedWrapper = $(fixedWrapper);
        if (!$fixedWrapper && $fixedWrapper.length <= 0) return;

        if (isUsed()) {
            $fixedWrapper.show();
        } else {
            $fixedWrapper.hide();
        }
        
    };

    var handler_Scroll = function () {
        let $fixedWrapper = $(fixedWrapper);
        if (!$fixedWrapper && $fixedWrapper.length <= 0) return;

        let $pricesButtonHolder = $(pricesButtonHolder);
        let $checkoutButtonHolder = $(checkoutButtonHolder);

        if (!isUsed()) {
            if ($pricesButtonHolder && $pricesButtonHolder.length) {
                $pricesButtonHolder.hide();
            }
            if ($checkoutButtonHolder && $checkoutButtonHolder.length) {
                $checkoutButtonHolder.hide();
            }
            return;
        }

        let currentTop = $(window).scrollTop() + (GetBreakpointHeight() / 2);
        let currentBottom = currentTop;
        let $anchor = $('#hotel-prices-mobile-anchor');
        if (!$anchor || $anchor.length <= 0) {
            $anchor = $fixedWrapper.parent();
        }
        if (!$anchor || $anchor.length <= 0) return;

        let pricesButtonHeight = 0;
        if ($pricesButtonHolder && $pricesButtonHolder.length) {
            pricesButtonHeight = $pricesButtonHolder.outerHeight(true);
        }

        let checkoutButtonHeight = 0;
        if ($checkoutButtonHolder && $checkoutButtonHolder.length) {
            checkoutButtonHeight = $checkoutButtonHolder.outerHeight(true);
        }

        let offsetTop = 12;
        let anchorTop = $anchor.offset().top;
        let anchorBottom = $fixedWrapper.parent().offset().top + $fixedWrapper.parent().outerHeight(true);

        let isTopPosition = (currentTop - pricesButtonHeight) < (anchorTop - offsetTop);
        let isBottomPostion = (currentBottom + checkoutButtonHeight) >= anchorBottom;

        if (isTopPosition || isBottomPostion || !has_search_result()) {
            $checkoutButtonHolder.hide();
            $pricesButtonHolder.show();
        } else {
            $pricesButtonHolder.hide();
            $checkoutButtonHolder.show();
        }
        
    };

    function updatePriceStickerContainer() {
        handler_Resize();
        handler_Scroll();
    };
    global.updatePriceStickerContainer = updatePriceStickerContainer;
    updatePriceStickerContainer();

    $(window).on('resize', handler_Resize);
    $(window).on('scroll', handler_Scroll);
    /* */
});

AppLoader.ready(function () {
    let searchbar = '.searchbar-container';
    let searchcriteria = '.search-criteria-container';
    function has_search_criteria() {
        return !!(searchViewModel && searchViewModel.HasDates() && searchViewModel.HasDepartureAirportCode());
    };

    if (has_search_criteria() && GetBreakpointWidth() < 768) {
        hideSection($(searchbar));
        showSection($(searchcriteria));
    }

    $(searchcriteria).on('click', function (e) {
        let $this = $(this);
        hideSection($this);
        showSection($this.parent().find(searchbar));

        if (typeof updatePriceStickerContainer == 'function') {
            updatePriceStickerContainer();
        }

    });

    
    function setVisibleSearchCriteria(val) {
        if (has_search_criteria() && GetBreakpointWidth() < 768 && val) {
            hideSection($(searchbar));
            showSection($(searchcriteria));
        } else {
            hideSection($(searchcriteria));
            showSection($(searchbar));
        }
    };
    global.setVisibleSearchCriteria = setVisibleSearchCriteria;

    $(window).on('resize', function () {
        if (GetBreakpointWidth() >= 768) {
            setVisibleSearchCriteria(false);
        }
    });

});

//AppLoader.setReady();